const _lineObjectTypes = [
    "ApproachControl",
    "SupplementalLine",
    "SECTOR",
    "ARTCC",
    "AAV",
    "DP",
    "AIRWAY",
    "MilitaryRoutes",
    "TAV",
    "FAV",
];
export const lineObjectTypes = _lineObjectTypes;
const _symbolObjectTypes = [
    "WAYPOINT",
    "TACAN",
    "NDB",
    "VOR",
    "AIRPORT",
    "EmergencyAirport",
];
export const symbolObjectTypes = _symbolObjectTypes;
export function isGeomapSymbolFeature(feature) {
    return "symbolId" in feature.properties;
}
export function isGeomapTextFeature(feature) {
    return "textObjectId" in feature.properties;
}
export function isGeomapPointFeature(feature) {
    return feature.geometry.type === "Point" && (!isGeomapSymbolFeature(feature) && !isGeomapTextFeature(feature));
}
export function isGeomapLineFeature(feature) {
    return !isGeomapPointFeature(feature) && !isGeomapSymbolFeature(feature) && !isGeomapTextFeature(feature);
}
export const geomapSymbolMap = {
    Airport: "\u040d",
    AirwayIntersections: "\u0409",
    EmergencyAirport: "\u0404",
    Heliport: "\u0402",
    IAF: "\u0405",
    NDB: "\u040c",
    Nuclear: "\u0403",
    Obstruction1: "\u0401",
    Obstruction2: "\u0401",
    OtherWaypoints: "\u040c",
    RNAV: "\u0408",
    RNAVOnlyWaypoint: "\u0407",
    Radar: "\u0405",
    SatelliteAirport: "\u040e",
    TACAN: "\u040f",
    DME: "\u040b",
    VOR: "\u040b",
};
export const targetSymbolMap = {
    correlatedBeacon: "\u0814",
    correlatedPrimary: "\u0812",
    identingBeacon: "\u0816",
    modeCIntruder: "\u0817",
    reducedSeparation: "\u0815",
    uncorrelatedBeacon: "\u0813",
    uncorrelatedPrimary: "\u0810",
    vfrBeacon: "\u0818",
};
export const positionSymbolMap = {
    flatTrack: "\u0800",
    coastTrack: "\u0802",
    freeTrack: "\u0801",
    frozenDatablock: "\u0803",
    hold: "\u0804",
};
//# sourceMappingURL=geomap.js.map